import React from 'react';
import { Booth } from 'models/cms/booths';
import BoothTemplate01 from './BoothTemplate01';
import BoothTemplate02 from './BoothTemplate02';
import BoothTemplate03 from './BoothTemplate03';
import BoothTemplate04 from './BoothTemplate04';
import BoothTemplate05 from './BoothTemplate05';
import BoothTemplate06 from './BoothTemplate06';
import BoothTemplate07 from './BoothTemplate07';
import BoothTemplateCUHK from './BoothTemplateCUHK';
import BoothTemplate08 from './BoothTemplate08';
import BoothTemplate09 from './BoothTemplate09';
import BoothTemplate10 from './BoothTemplate10';
import BoothTemplate11 from './BoothTemplate11';
import BoothTemplate12 from './BoothTemplate12';
import BoothTemplate13 from './BoothTemplate13';
import BoothTemplate14 from './BoothTemplate14';
import BoothtemplateBTA from './BoothTemplateBTA';

export interface BoothCMSTemplateProps {
  booth: Booth;
  handleClick: () => any;
}

const BoothCMSTemplate: React.FC<BoothCMSTemplateProps> = (props: BoothCMSTemplateProps) => {
  const { booth } = props;

  switch (booth?.appliedDesignCodename) {
    case '014':
      return <BoothTemplate14 {...props} />;
    case '013':
      return <BoothTemplate13 {...props} />;
    case '012':
      return <BoothTemplate12 {...props} />;
    case '011':
      return <BoothTemplate11 {...props} />;
    case '010':
      return <BoothTemplate10 {...props} />;
    case '009':
      return <BoothTemplate09 {...props} />;
    case '008':
      return <BoothTemplate08 {...props} />;
    case 'bta1014':
      return <BoothtemplateBTA {...props} />;
    case 'cuhk925':
      return <BoothTemplateCUHK {...props} />;
    case '007':
      return <BoothTemplate07 {...props} />;
    case '006':
      return <BoothTemplate06 {...props} />;
    case '005':
      return <BoothTemplate05 {...props} />;
    case '004':
      return <BoothTemplate04 {...props} />;
    case '003':
      return <BoothTemplate03 {...props} />;
    case '002':
      return <BoothTemplate02 {...props} />;
    case '001':
    default:
      return <BoothTemplate01 {...props} />;
  }
};

export default BoothCMSTemplate;
